import { forwardRef, type Ref, type SVGProps } from "react";
const IconCarSideOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28 12h-4l-3.42-5a2 2 0 0 0-1.74-1H6.32a2 2 0 0 0-1.84 1.21l-2.26 4.36a2.1 2.1 0 0 0-.22.92V20a2 2 0 0 0 2 2 4 4 0 0 0 8 0h8a4 4 0 0 0 8 0 2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2M14 8h4.84l2.73 4H14zM6.32 8H12v4H4.25zM8 24a2 2 0 1 1 2-2 2 2 0 0 1-2 2m16 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2m4-4h-.54a4 4 0 0 0-6.92 0h-9.08a4 4 0 0 0-6.92 0H4v-6h24z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCarSideOutlineSVG);
ForwardRef.displayName = "IconCarSideOutline";
export { ForwardRef as IconCarSideOutline };
